class $e46db5192eb49d53$export$eaa779a0e5689fc5 {
    constructor(marked){
        this.marked = marked;
    }
}
class $e46db5192eb49d53$export$3b1d32246777906f {
    constructor(mineCount){
        this.mineCount = mineCount;
    }
}
class $e46db5192eb49d53$export$ce2e3e0cb02af144 {
}
class $e46db5192eb49d53$export$985739bfa5723e08 {
    constructor(width, height, mineCount){
        this.width = width;
        this.height = height;
        this.mineCount = mineCount;
        this.remainingToOpen = width * height - mineCount;
        this.gameConclusion = null;
        this.stateMap = new Array(height);
        for(let y = 0; y < height; y++)this.stateMap[y] = new Array(width);
        this.mineMap = null;
    }
    get conclusion() {
        return this.gameConclusion;
    }
    getCellAt(x, y) {
        const state = this.stateMap[y][x];
        if (state !== "revealed") return new $e46db5192eb49d53$export$eaa779a0e5689fc5(state === "marked");
        if (!this.mineMap) throw "mineMap should be initialized before any cell state is revealed.";
        const contents = this.mineMap[y][x];
        return contents === "bomb" ? new $e46db5192eb49d53$export$ce2e3e0cb02af144() : new $e46db5192eb49d53$export$3b1d32246777906f(contents);
    }
    tryToggleMark(x, y) {
        const state = this.stateMap[y][x];
        if (state === "revealed") return false;
        this.stateMap[y][x] = state === "marked" ? undefined : "marked";
        return true;
    }
    canOpen(x, y) {
        const state = this.stateMap[y][x];
        return state !== "revealed" && state !== "marked";
    }
    tryOpen(x, y) {
        if (!this.canOpen(x, y)) return false;
        if (this.mineMap === null) this.initializeMines({
            x: x,
            y: y
        });
        if (!this.mineMap) throw "mineMap should be initialized before any cell state is revealed.";
        const contents = this.mineMap[y][x];
        if (contents === "bomb") this.explode();
        else this.openKnownGoodCell(x, y);
        return true;
    }
    openSurroundingIfSatisfied(x, y) {
        const cell = this.getCellAt(x, y);
        if (cell instanceof $e46db5192eb49d53$export$3b1d32246777906f) {
            const surroundingCoords = this.getSurroundingCoordinates(x, y);
            const openable = new Array();
            let markCount = 0;
            for(let i = 0; i < surroundingCoords.length; i++){
                const coords = surroundingCoords[i];
                const state = this.stateMap[coords.y][coords.x];
                if (state === "marked") markCount++;
                else if (state !== "revealed") openable.push(coords);
            }
            if (markCount === cell.mineCount) {
                for(let i = 0; i < openable.length; i++){
                    const coords = openable[i];
                    this.tryOpen(coords.x, coords.y);
                    if (this.gameConclusion) break;
                }
                return true;
            }
        }
        return false;
    }
    initializeMines(guaranteedCell) {
        this.mineMap = new Array(this.height);
        for(let y = 0; y < this.height; y++)this.mineMap[y] = new Array(this.width).fill(0);
        for(let plantedCount = 0; plantedCount < this.mineCount;){
            const x = Math.floor(Math.random() * this.width);
            const y = Math.floor(Math.random() * this.height);
            if (Math.abs(x - guaranteedCell.x) <= 1 && Math.abs(y - guaranteedCell.y) <= 1) continue;
            if (this.mineMap[y][x] === "bomb") continue;
            this.mineMap[y][x] = "bomb";
            const allSurrounding = this.getSurroundingCoordinates(x, y);
            for(let i = 0; i < allSurrounding.length; i++){
                const surrounding = allSurrounding[i];
                const contents = this.mineMap[surrounding.y][surrounding.x];
                if (contents !== "bomb") this.mineMap[surrounding.y][surrounding.x] = contents + 1;
            }
            plantedCount++;
        }
    }
    explode() {
        if (!this.mineMap) throw "mineMap should be initialized before any cell state is revealed.";
        this.gameConclusion = "loss";
        for(let y = 0; y < this.height; y++){
            for(let x = 0; x < this.width; x++)if (this.mineMap[y][x] === "bomb") this.stateMap[y][x] = "revealed";
        }
    }
    openKnownGoodCell(x, y) {
        if (!this.mineMap) throw "mineMap should be initialized before any cell state is revealed.";
        let knownGoodCells = [
            {
                x: x,
                y: y
            }
        ];
        for(;;){
            const cell = knownGoodCells.pop();
            if (!cell) break;
            const state = this.stateMap[cell.y][cell.x];
            if (state === "marked" || state === "revealed") continue;
            this.stateMap[cell.y][cell.x] = "revealed";
            this.remainingToOpen--;
            if (this.remainingToOpen === 0) {
                this.gameConclusion = "win";
                for(let y = 0; y < this.height; y++){
                    for(let x = 0; x < this.width; x++)if (this.mineMap[y][x] === "bomb") this.stateMap[y][x] = "marked";
                }
                break;
            }
            if (this.mineMap[cell.y][cell.x] === 0) knownGoodCells = knownGoodCells.concat(this.getSurroundingCoordinates(cell.x, cell.y));
        }
    }
    getSurroundingCoordinates(x, y) {
        const coordinates = new Array();
        if (y > 0) coordinates.push({
            x: x,
            y: y - 1
        });
        if (y < this.height - 1) coordinates.push({
            x: x,
            y: y + 1
        });
        if (x > 0) {
            coordinates.push({
                x: x - 1,
                y: y
            });
            if (y > 0) coordinates.push({
                x: x - 1,
                y: y - 1
            });
            if (y < this.height - 1) coordinates.push({
                x: x - 1,
                y: y + 1
            });
        }
        if (x < this.width - 1) {
            coordinates.push({
                x: x + 1,
                y: y
            });
            if (y > 0) coordinates.push({
                x: x + 1,
                y: y - 1
            });
            if (y < this.height - 1) coordinates.push({
                x: x + 1,
                y: y + 1
            });
        }
        return coordinates;
    }
}



class $687393886e0e2604$var$Constraint {
    constructor(surroundingBombCount, surroundingCoords){
        this.surroundingBombCount = surroundingBombCount;
        this.surroundingCoords = surroundingCoords;
    }
    validate(map) {
        let flagCount = 0;
        let unopenedCount = 0;
        for (const { x: x, y: y } of this.surroundingCoords)switch(map.cells[y][x]){
            case "flag":
                flagCount++;
            // (fallthrough)
            case undefined:
                unopenedCount++;
        }
        return flagCount <= this.surroundingBombCount && this.surroundingBombCount <= unopenedCount;
    }
}
class $687393886e0e2604$export$a5c7b93649eaf8f8 {
    constructor(cells){
        this.cells = cells;
    }
    static fromGame(game) {
        const rows = new Array(game.height);
        for(let y = 0; y < rows.length; y++){
            const cells = new Array(game.width);
            for(let x = 0; x < cells.length; x++){
                const cell = game.getCellAt(x, y);
                cells[x] = cell instanceof (0, $e46db5192eb49d53$export$eaa779a0e5689fc5) ? cell.marked ? "flag" : undefined : cell instanceof (0, $e46db5192eb49d53$export$ce2e3e0cb02af144) ? "flag" : cell instanceof (0, $e46db5192eb49d53$export$3b1d32246777906f) ? cell.mineCount : undefined;
            }
            rows[y] = cells;
        }
        return new $687393886e0e2604$export$a5c7b93649eaf8f8(rows);
    }
    getCellAt(coords) {
        return this.cells[coords.y][coords.x];
    }
    getSurroundingCellCoords(x, y) {
        return [
            {
                x: x - 1,
                y: y - 1
            },
            {
                x: x,
                y: y - 1
            },
            {
                x: x + 1,
                y: y - 1
            },
            {
                x: x - 1,
                y: y
            },
            {
                x: x + 1,
                y: y
            },
            {
                x: x - 1,
                y: y + 1
            },
            {
                x: x,
                y: y + 1
            },
            {
                x: x + 1,
                y: y + 1
            }
        ].filter((c)=>c.x >= 0 && c.y >= 0 && c.y < this.cells.length && c.x < this.cells[c.y].length);
    }
    getFlagCount() {
        let count = 0;
        for(let y = 0; y < this.cells.length; y++){
            for(let x = 0; x < this.cells[y].length; x++)if (this.cells[y][x] === "flag") count++;
        }
        return count;
    }
    getUnopenedUnflaggedCount() {
        let count = 0;
        for(let y = 0; y < this.cells.length; y++){
            for(let x = 0; x < this.cells[y].length; x++)if (this.cells[y][x] === undefined) count++;
        }
        return count;
    }
    getValidMapWith(newValue, at) {
        const rows = this.cells.slice();
        const cells = rows[at.y].slice();
        cells[at.x] = newValue;
        rows[at.y] = cells;
        const map = new $687393886e0e2604$export$a5c7b93649eaf8f8(rows);
        for (const coords of map.getSurroundingCellCoords(at.x, at.y)){
            const cell = map.getCellAt(coords);
            if (typeof cell === "number") {
                const constraint = new $687393886e0e2604$var$Constraint(cell, map.getSurroundingCellCoords(coords.x, coords.y));
                if (!constraint.validate(map)) return null;
            }
        }
        return map;
    }
    validateAll(totalMineCount) {
        let flagCount = 0;
        let unopenedCount = 0;
        for(let y = 0; y < this.cells.length; y++)for(let x = 0; x < this.cells[y].length; x++){
            const cell = this.cells[y][x];
            if (typeof cell === "number") {
                const constraint = new $687393886e0e2604$var$Constraint(cell, this.getSurroundingCellCoords(x, y));
                if (!constraint.validate(this)) return false;
            } else if (cell === "flag") {
                flagCount++;
                if (flagCount > totalMineCount) return false;
            } else unopenedCount++;
        }
        return unopenedCount + flagCount >= totalMineCount;
    }
}
class $687393886e0e2604$export$48abf8607da8ba96 {
    constructor(candidates, bombLikelihoodElsewhere){
        this.candidates = candidates;
        this.bombLikelihoodElsewhere = bombLikelihoodElsewhere;
    }
    getBombLikelihood(x, y) {
        return this.candidates.find((c)=>c.x === x && c.y === y)?.bombLikelihood ?? this.bombLikelihoodElsewhere;
    }
    static compute(game) {
        const map = game instanceof (0, $e46db5192eb49d53$export$985739bfa5723e08) ? $687393886e0e2604$export$a5c7b93649eaf8f8.fromGame(game) : game.map;
        const originalAdjacentUnopened = getAllAdjacentUnopened(map);
        const solutions = new Array();
        if (map.validateAll(game.mineCount)) visit(map, map.getFlagCount(), map.getUnopenedUnflaggedCount());
        function visit(map, currentFlagCount, currentUnopenedUnflaggedCount) {
            if (map === null) return;
            const next = findAdjacentUnopened(map);
            if (next === undefined) {
                solutions.push(map);
                return;
            }
            if (currentUnopenedUnflaggedCount > game.mineCount - currentFlagCount) visit(map.getValidMapWith("safe", next), currentFlagCount, currentUnopenedUnflaggedCount - 1);
            if (currentFlagCount < game.mineCount) visit(map.getValidMapWith("flag", next), currentFlagCount + 1, currentUnopenedUnflaggedCount - 1);
        }
        function findAdjacentUnopened(map) {
            for (const coord of originalAdjacentUnopened){
                if (map.getCellAt(coord) === undefined) return coord;
            }
        }
        if (solutions.length === 0) return new $687393886e0e2604$export$48abf8607da8ba96([]);
        function getAllAdjacentUnopened(map) {
            const coords = new Array();
            for(let y = 0; y < map.cells.length; y++){
                for(let x = 0; x < map.cells[y].length; x++)if (map.cells[y][x] === undefined) {
                    const surroundingCoords = map.getSurroundingCellCoords(x, y);
                    if (surroundingCoords.some((c)=>typeof map.getCellAt(c) === "number")) coords.push({
                        x: x,
                        y: y
                    });
                }
            }
            return coords;
        }
        const averageFlagCount = solutions.reduce((prev, solution)=>prev + solution.getFlagCount(), 0) / solutions.length;
        const averageRemainingMines = game.mineCount - averageFlagCount;
        const nonadjacentUnopenedCellCount = map.getUnopenedUnflaggedCount() - originalAdjacentUnopened.length;
        const bombLikelihoodElsewhere = averageRemainingMines / nonadjacentUnopenedCellCount;
        return new $687393886e0e2604$export$48abf8607da8ba96(originalAdjacentUnopened.map((coords)=>({
                ...coords,
                bombLikelihood: solutions.reduce((prev, solution)=>prev + (solution.getCellAt(coords) === "flag" ? 1 : 0), 0) / solutions.length
            })), bombLikelihoodElsewhere);
    }
}



class $7e3eb9e0d162670a$export$563248cf1b99493a {
    constructor(renderWidth, renderHeight, gameWidth, gameHeight){
        this.renderSize = {
            width: renderWidth,
            height: renderHeight
        };
        this.gameSize = {
            width: gameWidth,
            height: gameHeight
        };
        const outerBounds = {
            x: 0,
            y: 0,
            width: this.renderSize.width,
            height: this.renderSize.height
        };
        const aspect = {
            width: gameWidth,
            height: gameHeight
        };
        this.minefieldBounds = $7e3eb9e0d162670a$export$563248cf1b99493a.fitRectangle(aspect, outerBounds);
        this.cellSize = this.minefieldBounds.width / gameWidth;
    }
    getCellCoordinatesByMouseLocation(mouseLocation) {
        const x = Math.floor((mouseLocation.x - this.minefieldBounds.x) / this.cellSize);
        if (x < 0 || x >= this.gameSize.width) return null;
        const y = Math.floor((mouseLocation.y - this.minefieldBounds.y) / this.cellSize);
        if (y < 0 || y >= this.gameSize.height) return null;
        return {
            x: x,
            y: y
        };
    }
    getCellBorderX(cellX) {
        return Math.floor(this.minefieldBounds.x + this.cellSize * cellX);
    }
    getCellBorderY(cellY) {
        return Math.floor(this.minefieldBounds.y + this.cellSize * cellY);
    }
    getCellBounds(cellX, cellY) {
        const x = this.getCellBorderX(cellX);
        const y = this.getCellBorderY(cellY);
        return {
            x: x,
            y: y,
            width: this.getCellBorderX(cellX + 1) - x,
            height: this.getCellBorderY(cellY + 1) - y
        };
    }
    static fitRectangle(aspect, outerBounds) {
        if (outerBounds.width * aspect.height < outerBounds.height * aspect.width) {
            const correctedHeight = outerBounds.width * aspect.height / aspect.width;
            return {
                x: 0,
                y: (outerBounds.height - correctedHeight) / 2,
                width: outerBounds.width,
                height: correctedHeight
            };
        } else {
            const correctedWidth = outerBounds.height * aspect.width / aspect.height;
            return {
                x: (outerBounds.width - correctedWidth) / 2,
                y: 0,
                width: correctedWidth,
                height: outerBounds.height
            };
        }
    }
}


class $621f3774f67738fc$export$88530751e3977073 {
    constructor(game, minefieldContainer){
        this.mouseDownCell = null;
        this.isMouseCaptured = false;
        this.heatmap = null;
        this.drawHeatmap = false;
        this.alwaysDrawHeatmap = false;
        this.drawBestMoves = false;
        this.alwaysDrawBestMoves = false;
        this.teachBestMoves = false;
        this.autoFlag = false;
        this.autoOpen = false;
        this.game = game;
        const canvas = document.createElement("canvas");
        canvas.style.touchAction = "manipulation";
        const context = canvas.getContext("2d");
        if (!context) throw "Unable to obtain a 2D drawing context.";
        this.context = context;
        this.minefieldContainer = minefieldContainer;
        minefieldContainer.appendChild(canvas);
        window.addEventListener("resize", ()=>this.refreshCanvasLayout());
        this.refreshCanvasLayout();
        canvas.addEventListener("mousedown", (ev)=>this.onMouseDown(ev));
        canvas.addEventListener("mousemove", (ev)=>this.onMouseMove(ev));
        canvas.addEventListener("mouseup", (ev)=>this.onMouseUp(ev));
        canvas.addEventListener("dblclick", (ev)=>this.onDoubleClick(ev));
        canvas.addEventListener("contextmenu", (ev)=>this.onContextMenu(ev), false);
        window.addEventListener("keypress", (ev)=>this.onKeyPress(ev));
    }
    refreshCanvasLayout() {
        const devicePixelRatio = window.devicePixelRatio || 1;
        const devicePixelWidth = this.minefieldContainer.clientWidth * devicePixelRatio;
        const devicePixelHeight = this.minefieldContainer.clientHeight * devicePixelRatio;
        if (this.layout && this.layout.renderSize.width === devicePixelWidth && this.layout.renderSize.height === devicePixelHeight) return;
        this.layout = new (0, $7e3eb9e0d162670a$export$563248cf1b99493a)(devicePixelWidth, devicePixelHeight, this.game.width, this.game.height);
        const canvas = this.context.canvas;
        canvas.style.width = this.minefieldContainer.clientWidth + "px";
        canvas.style.height = this.minefieldContainer.clientHeight + "px";
        canvas.width = devicePixelWidth;
        canvas.height = devicePixelHeight;
        this.render();
    }
    onContextMenu(ev) {
        ev.preventDefault();
        if (this.game.conclusion) return;
        const coords = this.getCellByMouseLocation(ev);
        if (coords && this.game.tryToggleMark(coords.x, coords.y)) {
            this.afterMove();
            this.render();
        }
    }
    onMouseDown(ev) {
        if (this.game.conclusion) return;
        if (ev.button === 0) {
            this.isMouseCaptured = true;
            this.updateMouseDownCell(ev);
        }
    // Right-click is already handled by the contextmenu event which is the only way to get long presses working in
    // touch interfaces, synced to the haptic feedback. Haven’t found a good way to distinguish right-click from
    // long press. Waiting until mouseup to mark the cell is at least consistent with how left-click behaves.
    }
    onMouseMove(ev) {
        if (this.isMouseCaptured) this.updateMouseDownCell(ev);
    }
    onMouseUp(ev) {
        if (ev.button === 0) {
            this.isMouseCaptured = false;
            if (this.mouseDownCell) {
                if (this.game.canOpen(this.mouseDownCell.x, this.mouseDownCell.y)) {
                    let skipMove = false;
                    if (this.teachBestMoves && !this.drawBestMoves && this.heatmap !== null) {
                        const loseLikelihood = this.heatmap.getBombLikelihood(this.mouseDownCell.x, this.mouseDownCell.y);
                        if (loseLikelihood !== undefined && loseLikelihood > this.getBestMoveLoseLikelihood()) {
                            this.drawBestMoves = true;
                            skipMove = true;
                        }
                    }
                    if (!skipMove) {
                        this.game.tryOpen(this.mouseDownCell.x, this.mouseDownCell.y);
                        this.afterMove();
                    }
                }
                this.mouseDownCell = null;
                this.render();
            }
        }
    }
    onKeyPress(ev) {
        switch(ev.key){
            case "h":
                this.drawHeatmap = !this.drawHeatmap;
                this.render();
                break;
            case "H":
                this.alwaysDrawHeatmap = !this.alwaysDrawHeatmap;
                this.drawHeatmap = this.alwaysDrawHeatmap;
                this.render();
                break;
            case "b":
                this.drawBestMoves = !this.drawBestMoves;
                this.render();
                break;
            case "B":
                this.alwaysDrawBestMoves = !this.alwaysDrawBestMoves;
                this.drawBestMoves = this.alwaysDrawBestMoves;
                this.render();
                break;
            case "t":
                this.teachBestMoves = !this.teachBestMoves;
                break;
            case "a":
                this.autoFlag = !this.autoFlag;
                this.automate();
                break;
            case "A":
                this.autoOpen = !this.autoOpen;
                this.automate();
                break;
        }
    }
    afterMove() {
        if (!this.alwaysDrawHeatmap) this.drawHeatmap = false;
        if (!this.alwaysDrawBestMoves) this.drawBestMoves = false;
        this.heatmap = (0, $687393886e0e2604$export$48abf8607da8ba96).compute(this.game);
        this.automate();
    }
    automate() {
        if (this.heatmap === null) return;
        let needsRender = false;
        while(true){
            let anyChange = false;
            if (this.autoFlag) {
                for (const candidate of this.heatmap.candidates)if (candidate.bombLikelihood === 1) {
                    this.game.tryToggleMark(candidate.x, candidate.y);
                    // Heatmap still needs to be updated; otherwise, 'best move' will be referring to marking a flag which is already marked.
                    anyChange = true;
                }
            }
            if (this.autoOpen) {
                for (const candidate of this.heatmap.candidates)if (candidate.bombLikelihood === 0) {
                    this.game.tryOpen(candidate.x, candidate.y);
                    anyChange = true;
                }
            }
            if (!anyChange) break;
            needsRender = true;
            this.heatmap = (0, $687393886e0e2604$export$48abf8607da8ba96).compute(this.game);
        }
        if (needsRender) this.render();
    }
    onDoubleClick(ev) {
        if (this.game.conclusion) return;
        if (ev.button === 0) {
            const coords = this.getCellByMouseLocation(ev);
            if (coords && this.game.openSurroundingIfSatisfied(coords.x, coords.y)) {
                this.afterMove();
                this.render();
            }
        }
    }
    updateMouseDownCell(ev) {
        const coords = this.getCellByMouseLocation(ev);
        if (!$621f3774f67738fc$export$88530751e3977073.areSame(coords, this.mouseDownCell)) {
            this.mouseDownCell = coords;
            this.render();
        }
    }
    static areSame(first, second) {
        if (!first) return !second;
        if (!second) return false;
        return first.x === second.x && first.y === second.y;
    }
    getCellByMouseLocation(ev) {
        const devicePixelRatio = window.devicePixelRatio || 1;
        return this.layout.getCellCoordinatesByMouseLocation({
            x: ev.offsetX * devicePixelRatio,
            y: ev.offsetY * devicePixelRatio
        });
    }
    render() {
        const { renderSize: renderSize, minefieldBounds: minefieldBounds, cellSize: cellSize } = this.layout;
        this.context.clearRect(0, 0, renderSize.width, renderSize.height);
        this.context.fillStyle = "#d0d0d0";
        this.context.fillRect(minefieldBounds.x, minefieldBounds.y, minefieldBounds.width, minefieldBounds.height);
        this.context.strokeStyle = "#a0a0a0";
        this.context.lineWidth = 1;
        for(let y = 0; y < this.game.height; y++){
            const pixelY = this.layout.getCellBorderY(y);
            this.context.beginPath();
            this.context.moveTo(minefieldBounds.x, pixelY);
            this.context.lineTo(minefieldBounds.x + minefieldBounds.width, pixelY);
            this.context.stroke();
        }
        for(let x = 0; x < this.game.width; x++){
            const pixelX = this.layout.getCellBorderX(x);
            this.context.beginPath();
            this.context.moveTo(pixelX, minefieldBounds.y);
            this.context.lineTo(pixelX, minefieldBounds.y + minefieldBounds.height);
            this.context.stroke();
        }
        this.context.font = "bold " + cellSize * 0.5 + "px Georgia";
        const drawBestMovesAtLoseLikelihood = this.drawBestMoves && this.game.conclusion === null ? this.getBestMoveLoseLikelihood() : null;
        for(let y = 0; y < this.game.height; y++)for(let x = 0; x < this.game.width; x++)this.drawCell({
            x: x,
            y: y
        }, this.layout.getCellBounds(x, y), cellSize, drawBestMovesAtLoseLikelihood);
    }
    getBestMoveLoseLikelihood() {
        if (this.heatmap === null) return null;
        if (this.heatmap.candidates.some((c)=>c.bombLikelihood === 0 || c.bombLikelihood === 1)) return 0;
        return Math.min(...this.heatmap.candidates.map((c)=>c.bombLikelihood), ...this.heatmap.bombLikelihoodElsewhere !== undefined ? [
            this.heatmap.bombLikelihoodElsewhere
        ] : []);
    }
    drawCell(coords, cellBounds, cellSize, drawBestMovesAtLoseLikelihood) {
        const { x: x, y: y } = coords;
        const isMouseDown = this.mouseDownCell && this.mouseDownCell.x === x && this.mouseDownCell.y === y;
        const cell = this.game.getCellAt(x, y);
        if (cell instanceof (0, $e46db5192eb49d53$export$eaa779a0e5689fc5)) {
            if (cell.marked || !isMouseDown) {
                const borderSize = cellSize * 0.1;
                const right = cellBounds.x + cellBounds.width;
                const bottom = cellBounds.y + cellBounds.height;
                this.context.beginPath();
                this.context.moveTo(cellBounds.x, cellBounds.y);
                this.context.lineTo(cellBounds.x, bottom);
                this.context.lineTo(cellBounds.x + borderSize, bottom - borderSize);
                this.context.lineTo(cellBounds.x + borderSize, cellBounds.y + borderSize);
                this.context.lineTo(right - borderSize, cellBounds.y + borderSize);
                this.context.lineTo(right, cellBounds.y);
                this.context.closePath();
                this.context.fillStyle = "#e8e8e8";
                this.context.fill();
                this.context.beginPath();
                this.context.moveTo(right, bottom);
                this.context.lineTo(right, cellBounds.y);
                this.context.lineTo(right - borderSize, cellBounds.y + borderSize);
                this.context.lineTo(right - borderSize, bottom - borderSize);
                this.context.lineTo(cellBounds.x + borderSize, bottom - borderSize);
                this.context.lineTo(cellBounds.x, bottom);
                this.context.closePath();
                this.context.fillStyle = "#a0a0a0";
                this.context.fill();
            }
            if (!cell.marked) {
                const bombLikelihood = this.heatmap?.getBombLikelihood(x, y);
                if (this.drawHeatmap) {
                    const drawAtFullCertainty = true;
                    if (bombLikelihood !== undefined && (drawAtFullCertainty || bombLikelihood !== 0 && bombLikelihood !== 1)) {
                        this.context.fillStyle = `hsl(${(1 - bombLikelihood) * 120} 100% 50% / 25%)`;
                        this.context.fillRect(cellBounds.x, cellBounds.y, cellBounds.width, cellBounds.height);
                    }
                }
                if (drawBestMovesAtLoseLikelihood !== null) {
                    if (bombLikelihood === 1 || bombLikelihood === drawBestMovesAtLoseLikelihood) {
                        this.context.strokeStyle = "rgba(255, 255, 0, 0.5)";
                        this.context.lineWidth = 6;
                        this.context.strokeRect(cellBounds.x + 2, cellBounds.y + 2, cellBounds.width - 5, cellBounds.height - 5);
                    }
                }
            }
        }
        const text = cell instanceof (0, $e46db5192eb49d53$export$eaa779a0e5689fc5) ? cell.marked ? "\uD83D\uDEA9" : null : cell instanceof (0, $e46db5192eb49d53$export$3b1d32246777906f) ? cell.mineCount !== 0 ? cell.mineCount.toString() : null : "\uD83D\uDCA5";
        if (text !== null) {
            if (cell instanceof (0, $e46db5192eb49d53$export$3b1d32246777906f)) this.context.fillStyle = [
                "blue",
                "green",
                "#e00",
                "darkblue",
                "brown",
                "darkcyan",
                "black",
                "gray"
            ][cell.mineCount - 1];
            else this.context.fillStyle = "black";
            this.drawCenteredText(text, cellBounds);
        }
    }
    drawCenteredText(text, bounds) {
        const metrics = this.context.measureText(text);
        this.context.textBaseline = "middle";
        this.context.fillText(text, bounds.x + (bounds.width - metrics.width) / 2, bounds.y + bounds.height / 2);
    }
}


const $b4e14b6b8da86996$var$game = new (0, $e46db5192eb49d53$export$985739bfa5723e08)(30, 16, 99);
new (0, $621f3774f67738fc$export$88530751e3977073)($b4e14b6b8da86996$var$game, document.getElementById("minefield-container"));


//# sourceMappingURL=index.0826f82e.js.map
